<template>
  <div class="container">
    <div class="blogArticle">
      <div class="row">
        <div class="col-xs-12 col-12 pt-lg-3">
          <h1>{{ getTitle(post) }}</h1>
          <!-- <BlogCategoryList :categories="post.tribe_events_cat" v-if="post.tribe_events_cat" class="cat" /> -->
        </div>
        <div class="col-lg-8 col-xs-12">
          <div class="col-xs-12 blogArticle--content" v-html="getContent(post)" />
        </div>
        <div class="offset-lg-1 col-lg-3 col-xs-12">
          <aside class="blogArticle--aside">
            <p>
              <strong>Beitrag teilen</strong>
            </p>
            <Share />
          </aside>
        </div>
      </div>
    </div>

    <client-only>
      <div class="iframe-wrapper" v-if="iFrameUrl()">
        <button type="button" class="btn btn-primary w-100" @click="toggleClass()">
          <template v-if="isOpen"> Schließen </template>
          <template v-else> Jetzt Ticket sichern </template>
        </button>
        <iframe
          v-if="isOpen"
          class="event-brite-iframe"
          :src="iFrameUrl()"
          :data-automation="`checkout-widget-iframe-${getDataUID()}`"
          allowtransparency="true"
          frameborder="0"
          scrolling="auto"
          width="100%"
          height="425"
        />
      </div>
    </client-only>
  </div>
</template>

<script>
import { useBlogStore } from '~/stores/blog';
import Share from '~/components/Blog/Share';
import BlogCategoryList from '~/components/Blog/CategoryList';

export default {
  name: 'blog-article',
  async asyncData({ route, $axios }) {
    const { event } = route.params;
    const blogStore = useBlogStore();
    const postPromise = $axios.$get('/blog-api/' + 'tribe_events?slug=' + event);
    const categoriesPromise = $axios.$get('/blog-api/' + 'categories/');
    const tagsPromise = $axios.$get('/blog-api/' + 'tags/?per_page=100');

    const [post, categories, tags] = await Promise.all([postPromise, categoriesPromise, tagsPromise]);

    blogStore.setPost(post[0], 'tribe_events');
    blogStore.setCategories(categories);
    blogStore.setTags(tags);

    return { post: post[0] };
  },

  data() {
    return {
      maxItems: 3,
      showTotal: 0,
      showItems: 0,

      isOpen: false,
    };
  },

  setup() {
    const blogStore = useBlogStore();
    const getThumbnail = () => {
      blogStore.getFeaturedImage();
      return blogStore.featuredImage;
    };
    return {
      getThumbnail,
    };
  },
  methods: {
    getContent(post) {
      return post?.content?.rendered
        .replaceAll('https://www.papierfischer.de//blog/wp-content/', '/blog-content/wp-content/')
        .replaceAll('/blog/event', '/blog/events');
    },
    getCurrentLink() {
      if (process.client) {
        return window.location.origin + this.$router.currentRoute.path;
      } else {
        return this.$i18n['__baseUrl'] + this.$router.currentRoute.path;
      }
    },

    getTitle(post) {
      return post?.title?.rendered;
    },

    eventsToggleClass() {
      const dropdownButton = document.querySelector('.tribe-events-c-subscribe-dropdown');

      dropdownButton?.addEventListener('click', () => {
        dropdownButton.classList.toggle('open-dropdown');
      });
    },

    getDataUID() {
      // console.log(this.post?.meta);
      const EventURL = this.post?.meta?._EventURL ? this.post?.meta?._EventURL : '';
      return EventURL.slice(-12) ? EventURL.slice(-12) : false;
    },

    iFrameUrl() {
      if (this.getDataUID()) {
        return `https://www.eventbrite.com/checkout-external?eid=${this.getDataUID()}&amp;parent=${this.getCurrentLink()}`;
      }
    },

    toggleClass() {
      this.isOpen = !this.isOpen;
    },
  },
  head() {
    const blogStore = useBlogStore();
    let metaData = {};
    if (typeof blogStore.post.yoast_head_json !== 'undefined' && blogStore.post.yoast_head_json) {
      metaData = blogStore.post.yoast_head_json;
    } else if(typeof blogStore.event.yoast_head_json !== 'undefined' && blogStore.event.yoast_head_json) {
      metaData = blogStore.event.yoast_head_json;
    } else if(blogStore.postMetadata) {
      metaData = blogStore.postMetadata;
    }
    
    const scriptTags = [
      // {
      //   src: 'https://www.eventbrite.com/static/widgets/eb_widgets.js?ver=12.1',
      //   id: 'eventbrite-widget-js',
      //   async: true
      // },
      {
        src: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyD1lEnylNxwDSlTVoFrZQyy_EWQau2zHsw&amp;callback=Function.prototype&amp;ver=6.0.13.1',
        id: 'tribe-events-google-maps-js',
        async: true,
      },
    ];
    return {
      // @ts-ignore
      script: scriptTags,
       title: metaData.og_title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: metaData.og_description || '',
        },
        {
          hid: 'robots',
          name: 'robots',
          content: (metaData?.robots?.follow + "," +metaData?.robots?.index).toUpperCase() || '',
        },
        {
          hid: 'canonical',
          rel: 'canonical',
          href: metaData.canonical || '',
        },
        // og locale, type, title, description, url, og_site_name, og_image
        {
          hid: 'og:locale',
          property: 'og:locale',
          content: metaData.og_locale || '',
        },
        {
          hid: 'og:type',
          property: 'og:type',
          content: metaData.og_type || '',
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: metaData.og_title || '',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: metaData.og_description || '',
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: metaData.og_url || '',
        },
        {
          hid: 'og:site_name',
          property: 'og:site_name',
          content: metaData.og_site_name || '',
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: metaData.og_image[0]?.url || '',
        },
      ]
    };
  },

  mounted() {
    this.eventsToggleClass();
    setTimeout(() => {
      // let checkoutEBScript = document.createElement('script')
      // checkoutEBScript.innerText = `window.EBWidgets.createWidget( { widgetType: 'checkout', eventId: ${this.getDataUID()}, iframeContainerId: 'eventbrite-widget-1', });`;
      // document.head.appendChild(checkoutEBScript);

      //Map Code
      const googleMapList = document.querySelectorAll('.tribe-events-gmap');
      if (googleMapList && googleMapList.length > 0) {
        if (googleMapList[0] && googleMapList[0] != 'undefined' && googleMapList[0] != 'null') {
          if (googleMapList[0].href && googleMapList[0].href != 'undefined' && googleMapList[0].href != 'null') {
            let firstSplitAddress = googleMapList[0].href.split('query=');
            if (firstSplitAddress && firstSplitAddress.length > 0 && firstSplitAddress[1]) {
              let decodeQuery = unescape(firstSplitAddress[1]);
              if (decodeQuery) {
                let finalSplitAddress = decodeQuery.split(',');
                if (finalSplitAddress[0] && finalSplitAddress[1]) {
                  let mapScript = document.createElement('script');
                  mapScript.innerText = `var mapProp= { center:new google.maps.LatLng(${finalSplitAddress[0]},${finalSplitAddress[1]}), zoom:14, }; var map = new google.maps.Map(document.getElementById("tribe-events-gmap-0"),mapProp);`;
                  document.head.appendChild(mapScript);
                }
              }
            }
          }
        }
      }
    }, 2000);
  },

  components: {
    Share,
    BlogCategoryList,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/blog/blogStyles.scss';

.event-brite-iframe {
  height: 500px;
  max-height: 80vh;
}
</style>
